import { Button } from "@admin/components/atoms/Button";
import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import {
  Dish,
  getallDishesByCompanyId,
  UpsertModalType,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { UpsertProcessingProductModal } from "../Modals/UpsertProcessingProductModal";
import { DeleteMyListModal } from "./Modals/DeleteMyListModal";

interface ProcessedProductsTableProps {
  companyId?: string;
  selectedLocationId?: string;
}

export function ProcessedProductsTable({
  companyId,
  selectedLocationId,
}: ProcessedProductsTableProps) {
  const { t } = useTranslation();
  const { data: dishesByCompany, isPending } = useQuery({
    queryKey: ["dishesByCompany", companyId],
    queryFn: () => getallDishesByCompanyId(companyId ?? ""),
    enabled: !!companyId,
  });
  const [selectedDish, setSelectedDish] = useState<Dish>();
  const [isAddProcessedProductModalOpen, setIsAddProcessedProductModalOpen] =
    useState(false);
  const [isEditProcessedProductModalOpen, setIsEditProcessedProductModalOpen] =
    useState(false);
  const [
    isDeletePrcessedProductModalOpen,
    setIsDeleteProcessedProductModalOpen,
  ] = useState(false);

  const dataColumns: DataTableColumn<Dish>[] = [
    {
      header: t("common.Name"),
      accessorKey: "name",
      cell: ({ row }) => row.original.name,
    },
    {
      align: "center",
      header: t("common.Actions"),
      size: 110,
      cell: ({ row }) => (
        <div className="flex justify-center">
          <Button
            variant="clear"
            icon
            size="sm"
            onClick={() => setIsEditProcessedProductModalOpen(true)}
          >
            <i className="ki-filled ki-notepad-edit"></i>
          </Button>

          <Button
            onClick={() => setIsDeleteProcessedProductModalOpen(true)}
            icon
            property="danger"
            variant="clear"
            size="sm"
          >
            <i className="ki-filled ki-trash-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        loading={isPending}
        onRowClick={setSelectedDish}
        columns={dataColumns}
        data={dishesByCompany}
        title={t("food.Processed Product")}
        header={
          <Button
            onClick={() => setIsAddProcessedProductModalOpen(true)}
            size="sm"
          >
            <i className="ki-filled ki-plus-squared"></i>
            {t("food.Add New Product")}
          </Button>
        }
      />
      <UpsertProcessingProductModal
        open={isAddProcessedProductModalOpen}
        onClose={() => setIsAddProcessedProductModalOpen(false)}
        companyId={companyId}
        selectedLocationId={selectedLocationId}
        type={UpsertModalType.Add}
      />
      <UpsertProcessingProductModal
        open={isEditProcessedProductModalOpen}
        onClose={() => setIsEditProcessedProductModalOpen(false)}
        companyId={companyId}
        selectedLocationId={selectedLocationId}
        dish={selectedDish}
        type={UpsertModalType.Edit}
      />
      <DeleteMyListModal
        open={isDeletePrcessedProductModalOpen}
        onClose={() => setIsDeleteProcessedProductModalOpen(false)}
        id={selectedDish?.id ?? ""}
        type="processed"
        title={t("food.Processed Product")}
      />
    </>
  );
}
